import script from "./sliderPoint.vue?vue&type=script&setup=true&lang=ts"
export * from "./sliderPoint.vue?vue&type=script&setup=true&lang=ts"

import "./sliderPoint.vue?vue&type=style&index=0&id=ec553d52&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec553d52"]])

export default __exports__